const _version = "3.4.1"
function version() {
    return _version
}
export default version
